import DealerKit from "../../js/api";
import { reactive } from "vue";
const partsListState = reactive({ inventory: undefined });
const loadCallbacks = [];
function loadPartsList(page = 1, inventory = true, lastOrderSummary = false) {
    if (page === 1) {
        partsListState.inventory = undefined;
    }
    return DealerKit.parts.getParts(page, inventory, lastOrderSummary).then(response => {
        if (partsListState.inventory) {
            partsListState.inventory = partsListState.inventory.concat(response.data.data);
        }
        else {
            partsListState.inventory = response.data.data;
        }
        if (page < response.data.meta.last_page) {
            return loadPartsList(page + 1, inventory, lastOrderSummary);
        }
        else {
            loadCallbacks.forEach(cb => {
                cb(partsListState.inventory);
            });
            return partsListState.inventory;
        }
    });
}
function onPartsListLoaded(cb) {
    loadCallbacks.push(cb);
}
export { partsListState, loadPartsList, onPartsListLoaded };
